var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPaperShield(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.038 6.738v18.396h-14.3V11.372l.038-.191.073-.177.109-.162 3.884-3.884.162-.109.177-.073.19-.038h9.667zm-1 .999h-8.563l-3.738 3.738v12.658h12.301V7.737zm-5.756 2.873l.086.046.24.152c.901.547 2.024.955 3.374 1.123.172.021.316.13.39.3l.03.091.008.088v3.141c0 2.086-.952 4.062-2.55 5.288a6.355 6.355 0 01-1.588.9.494.494 0 01-.353 0 6.351 6.351 0 01-1.59-.9c-1.449-1.112-2.37-2.845-2.526-4.726l-.017-.283-.006-.279v-3.14c0-.245.185-.45.428-.48 1.473-.184 2.676-.652 3.614-1.275a.494.494 0 01.46-.046zm-.188 1.019l-.145.089a9.22 9.22 0 01-2.686 1.014l-.391.077-.114.017v2.725c0 1.7.734 3.312 1.972 4.363l.2.16a5.54 5.54 0 001 .616l.165.072.165-.072c.257-.121.51-.268.757-.438l.244-.177c1.223-.938 2.007-2.406 2.148-3.997l.017-.266.006-.26v-2.725l-.147-.024c-1.187-.212-2.21-.6-3.07-1.101l-.121-.073zm2.78 2.564a.476.476 0 01.137.523l-.036.085-.055.078-2.937 3.307a.465.465 0 01-.172.12l-.08.029-.106.014a.49.49 0 01-.202-.043l-.074-.038-.076-.059-1.913-1.867a.48.48 0 010-.688.488.488 0 01.518-.103l.093.044.077.06 1.544 1.507 2.595-2.924a.493.493 0 01.686-.045z"
  }));
}

export default SvgPaperShield;